import checkout from "./form";

const {
  formField: {
    period,
    firstTime,
    additional,

    taxpayers,
    taxCode,
    taxAgentName,
    taxAgentCode,

    chiefAccountant,
    certificateNumber,
    unitHeads,
    dateFounded,
  },
} = checkout;

const initialValues = {
  [period.name]: "",
  [firstTime.name]: "",
  [additional.name]: "",

  [taxpayers.name]: "",
  [taxCode.name]: "",
  [taxAgentName.name]: "",
  [taxAgentCode.name]: "",

  [chiefAccountant.name]: "",
  [certificateNumber.name]: "",
  [unitHeads.name]: "",
  [dateFounded.name]: "",
};

export default initialValues;
